import React from 'react';
import { StyledDiv } from '../../Components/Styled';

const RequestCampaign = ({}) => {

    return (
        <React.Fragment>
            <StyledDiv>
                This is Request Campaign for product
            </StyledDiv>
        </React.Fragment>
    )
}

export default RequestCampaign;